import React, { Component } from 'react';
import Page from '../../containers/page';

import {
    Container,
    Row,
    Col,
    FormGroup, Label, Input, Button, UncontrolledAlert,
    Modal, ModalBody, ModalHeader, ModalFooter
} from 'reactstrap';

import { Link } from 'react-router-dom';

import ModalFormBuilder from '../../components/forms/modalFormBuilder';

import FormBuilder from '../../components/forms/formBuilder';
import { required } from '../../components/forms/validation';

import ListBuilder from '../../components/listBuilder';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import { API_ENDPOINT } from '../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import lIcon from '../../assets/svg/upitnik.svg'
import Comment from '../../assets/svg/koment.svg'
import Hart from '../../assets/svg/srce.svg';

import Isvg from 'react-inlinesvg'
import error from '../../assets/images/error.png';
import BankIdModal from '../../components/bankIdModal';
import InfoModal from '../../components/infoModal';


import ErrorModal from '../../components/errorModal';
import LogoHeader from '../../assets/svg/header-logo.png';
import LogoFooter from '../../assets/svg/footer-logo.png';
import Woman from '../../assets/svg/woman.png';
import i1 from '../../assets/svg/i1.png';
import i2 from '../../assets/svg/i2.png';
import i3 from '../../assets/svg/i3.png';
import locationIcon from '../../assets/svg/location.png'
import arrowLeftIcon from '../../assets/svg/arrow-left-icon.svg'

// import BankIDModal_v2 from '../../components/bankIDModal_v2';

import FooterComponent from './footerComponent';



import JsonToHtmlV2 from '../landingBuilder/jsonToHtml';
import defaultJSON_v2 from '../landingBuilder/default.json';

import defaultMainClinicGroup from '../landingBuilder/defaultMainClinicGroup.json';

import defaultInfoPages from '../landingBuilder/defaultInfoPages.json';


import MainClinicLandingPage from '../../components/mainClinicLandingPage';
import CustomSelectWithSearch from '../../components/forms/fields/customSelectWithSearch';
import TwoFactorAuthModal from '../../components/TwoFactorAuthModal';
import PhoneInput from 'react-phone-input-2';
import moment from 'moment';
import AgeLimitErrorModal from '../../components/ageLimitErrorModal';
import { VerifyAccountComponent } from '../../components/auth/2fa-v2.login.component';

function prepareJSON(json) {
    let arr = [];
    for (var key in json) {
        arr.push({
            ...json[key],
            __id: key
        })
    }
    return arr;
}

export const isStringAValidObjectId = (string) => {
    if (!string || typeof string !== 'string') return false;
    const regex = /^[a-f\d]{24}$/i;
    return regex.test(String(string))
}

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function iosDevice() {
    //return true;
    var userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
        return true;
    }
    else {
        return false;
    }
}


class LandingInformationPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0,
                'query-group': null
            },
            items: [],
            total: 0,
            loading: true,
            groups: [],
            languages: [],
            clinicIdx: 0,
            windowWidth: typeof window != 'undefined' && window.innerWidth ? window.innerWidth : 0,
            data: null,
            selectedClinic: null,
            estimatedWaitingTime: null,
            initialLanding: false,
            lastVisitedClinics: [],

            show2FAModal: false,
            queryUid: null,
            notAuthorized: false
        };
    }

    setLastGroupAlias = () => {
        if (this.props.uData && this.props.uData.patientGroups && this.props.uData.patientGroups.length) {
            let check = false
            for (let i = 0; i < this.props.uData.patientGroups.length; i++) {
                if (localStorage.groupAlias && localStorage.getItem('groupAlias') == this.props.uData.patientGroups[i].alias && this.props.uData.patientGroups[i]._noReferrals) {
                    localStorage.setItem('lastGroup', this.props.uData.patientGroups[i].alias);
                    break;
                }
            }

        }
    }

    get = () => {


        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));

        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, 'query-group': null })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, 'query-group': null })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }
        let alias = this.props[0].match.params.alias;
        let mainAlias = this.props[0].match.params.mainAlias;





        if (mainAlias && alias) {
            localStorage.setItem('groupAlias', alias);

            // this.checkVisitedGroups()

            this.forceUpdate();


            fetch(API_ENDPOINT + '/landing/page/clinic-group', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ alias, mainAlias })
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.props[0].history.push(`/`);

                } else {

                    this.setState({
                        data: result
                    }, () => {

                        if (this.state.data && this.state.data.defaultLanguage && this.state.data.defaultLanguage !== this.props.lang && this.state.data.defaultLanguage !== '') {
                            this.props.setLang(this.state.data.defaultLanguage)
                        }


                        if (this.state.data && this.state.data.defaultCurrency && this.state.data.defaultCurrency !== '') {
                            this.props.changeCurrency(this.state.data.defaultCurrency)
                        }

                        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                    })

                }
            });

            fetch(API_ENDPOINT + '/landing/page', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ alias, mainAlias })
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                } else {

                    if (result.favicon) {
                        let favicon = document.getElementById("favicon");
                        favicon.href = result.favicon;
                    } else if (result.logoChat) {
                        let favicon = document.getElementById("favicon");
                        favicon.href = result.logoChat;

                    } else {
                        favicon.href = '/favicon.ico';
                    }


                }
            });

        } else {
            localStorage.setItem('groupAlias', alias);
            // this.checkVisitedGroups()
            this.forceUpdate();


            fetch(API_ENDPOINT + '/landing/page', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ alias })
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.props[0].history.push(`/`);

                } else {
                    if (result && result.landingJSON_v2) {
                        let backgroundColor = ""
                        for (const key in result.landingJSON_v2) {

                            if (result.landingJSON_v2[key]['parent'] === 'root' && result.landingJSON_v2[key]['visibility']) {
                                if (typeof window != 'undefined' && window.innerWidth < 480 && result.landingJSON_v2[key]['visibility']['xs']) {
                                    if (result.landingJSON_v2[key]['style']['backgroundColor']) {
                                        backgroundColor = result.landingJSON_v2[key]['style']['backgroundColor']
                                    } else {
                                        backgroundColor = ""
                                    }
                                } else if (typeof window != 'undefined' && window.innerWidth >= 480 && window.innerWidth < 1200 && result.landingJSON_v2[key]['visibility']['sm']) {
                                    if (result.landingJSON_v2[key]['style']['backgroundColor']) {
                                        backgroundColor = result.landingJSON_v2[key]['style']['backgroundColor']
                                    } else {
                                        backgroundColor = ""
                                    }
                                } else if (typeof window != 'undefined' && window.innerWidth >= 1200 && result.landingJSON_v2[key]['visibility']['lg']) {
                                    if (result.landingJSON_v2[key]['style']['backgroundColor']) {
                                        backgroundColor = result.landingJSON_v2[key]['style']['backgroundColor']
                                    } else {
                                        backgroundColor = ""
                                    }
                                }

                            }
                        }

                        this.setState({
                            landingBackgroundColor: backgroundColor
                        })
                    }

                    this.setState({
                        data: result,
                    }, () => {
                        if (result.favicon) {
                            let favicon = document.getElementById("favicon");
                            favicon.href = result.favicon;
                        } else if (result.logoChat) {
                            let favicon = document.getElementById("favicon");
                            favicon.href = result.logoChat;

                        } else {
                            favicon.href = '/favicon.ico';
                        }
                        console.log(this.state.data)
                        if (this.state.data && this.state.data.defaultLanguage && this.state.data.defaultLanguage !== this.props.lang && this.state.data.defaultLanguage !== '') {
                            this.props.setLang(this.state.data.defaultLanguage)
                        }

                        if (this.state.data && this.state.data.defaultCurrency && this.state.data.defaultCurrency !== '') {
                            this.props.changeCurrency(this.state.data.defaultCurrency)
                        }

                        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                    })

                }
            });
        }

        this.setLastGroupAlias();



    }
    getLastVisitedClinics = () => {
        if (typeof window != 'undefined' && localStorage.lastVisitedClinics) {
            let lastVisitedClinics = JSON.parse(localStorage.lastVisitedClinics);
            if (lastVisitedClinics && lastVisitedClinics.length > 3) {
                let newArr = [lastVisitedClinics[0], lastVisitedClinics[1], lastVisitedClinics[2]]
                lastVisitedClinics = newArr;
            }
            let alias = this.props[0]?.match?.params?.alias;

            if (lastVisitedClinics && lastVisitedClinics.length) {
                fetch(API_ENDPOINT + '/users/clinic-groups/last/visited', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({ lastVisitedClinics: lastVisitedClinics, alias: alias })
                }).then(res => res.json()).then((result) => {
                    if (result && result.length) {
                        let arr = [];
                        for (let i = 0; i < lastVisitedClinics.length; i++) {
                            if (result.filter(el => el._id == lastVisitedClinics[i]).length) {
                                arr.push(result.filter(el => el._id == lastVisitedClinics[i])[0])
                            }
                        }
                        this.setState({ lastVisitedClinics: arr })
                    }
                });
            }
        }
    }

    checkVisitedGroups = () => {
        setTimeout(() => {
            if (typeof window != 'undefined' && localStorage.groupAlias && this.props.uData && (this.props.uData.userLevel == 1 || this.props.uData.userLevel == 2 || (this.props.uData.userLevel == 20 && localStorage?.getItem?.('profile') == 'patient'))) {
                if (!this.props.uData.lastVisitedGroups || (this.props.uData.lastVisitedGroups && !this.props.uData.lastVisitedGroups.length) || (this.props.uData.lastVisitedGroups && this.props.uData.lastVisitedGroups[this.props.uData.lastVisitedGroups.length - 1].alias != localStorage.groupAlias)) {
                    this.props.checkVisitedGroups()

                }
            }
            if (this.state.data && this.state.data._id && !this.state.data.mainClinicGroup) {
                this.props.checkLastVisitedClinics(this.state.data._id)
            }
        }, 1000);
    }

    getSecureInfoPage = (informationPageId) => {
        if (!informationPageId) return;
        fetch(API_ENDPOINT + '/landing/secure/info-page', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ informationPageId })
        }).then(res => res.json()).then((result) => {
            if (result?._id) {
                this.setState({ infoPageData: result })
            } else {
                this.setState({ notAuthorized: true })
            }
        });

    }
    getInfoPageData = () => {
        const alias = this.props[0].match.params.alias;
        const slug = this.props[0].match.params.slug;
        if (!alias || !slug) return;

        let obj = {
            alias,
            slug
        }

        fetch(API_ENDPOINT + '/landing/info-page', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(res => res.json()).then((result) => {
            if (result?.needLoginPermission && result?._id) {
                this.getSecureInfoPage(result._id);
            } else if (result?._id) {
                this.setState({ infoPageData: result })
            }
        });
    }

    componentDidMount() {
        let params = getSearchParams(this.props[0].location.search);

        if (this.props[0].location && this.props[0].location.state && this.props[0].location.state.mitIdError) {
            console.log('alias mitid error', this.props[0].location && this.props[0].location.state && this.props[0].location.state.mitIdError);

            this.setState({ error: this.props[0].location.state.mitIdError }, () => {
                this.props[0].history.push({
                    state: {
                        mitIdError: null
                    }
                })
            })
        }

        if (params && params.qrCodeLink && params.stateForOpen) {

            if (decodeURIComponent(params.stateForOpen) === 'bankIdModal') {
                this.setState({
                    bankIdModal: true
                })
            } else if (decodeURIComponent(params.stateForOpen) === 'bankIdModalDaybook') {
                this.setState({
                    bankIdModalDaybook: true
                })
            } else if (decodeURIComponent(params.stateForOpen).indexOf('dropinBankId') !== -1) {
                this.setState({
                    bankIdModalDropIn: true,
                    selectedDropInForm: decodeURIComponent(params.stateForOpen).replace('dropinBankId', '')
                })
            } else if (decodeURIComponent(params.stateForOpen) === 'mainGroupLoginBankIdModal') {
                this.setState({
                    mainGroupLoginBankIdModal: true
                })
            } else if (decodeURIComponent(params.stateForOpen) === 'loginBankIdModal') {
                this.setState({
                    loginBankIdModal: true
                })
            } else if (decodeURIComponent(params.stateForOpen) === 'bankIdModal1') {
                this.setState({
                    bankIdModal1: true
                })
            } else if (decodeURIComponent(params.stateForOpen) === 'bankIdModalWaitingRoom') {
                this.setState({
                    bankIdModalWaitingRoom: true
                })
            }


        }
        window.addEventListener('resize', this.resizeWindow);

        this.get();

        // this.getLastVisitedClinics()

        if (this.props?.[0]?.location?.search && this.props[0].location.search.indexOf?.('uid') !== -1) {
            let s = this.props[0].location.search;
            let uid = s.split('uid=')[1];
            if (uid && uid.includes('&')) uid = uid.split('&')[0];

        }

        if (this.props?.[0]?.location?.search && this.props[0].location.search.indexOf?.('user_id') !== -1 && this.props[0].location.search.indexOf?.('secret_key') !== -1) {
            try {
                const alias = this.props[0].match?.params?.alias;
                const url = new URL(window.location.href);
                if (url) {
                    const userId = url.searchParams.get('user_id');
                    const secretKey = url.searchParams.get('secret_key');
                    if (userId && secretKey) {
                        this.open2FAModal(userId, secretKey, alias);
                    }
                }
            } catch (err) { }
        }

        if (this.props.uData && this.state.data) {
            this.checkUserAuth();
        }
        if (this.props.checkSSNSwitchCountries) {
            this.props.checkSSNSwitchCountries()
        }


        this.getInfoPageData();

    }

    componentWillUnmount() {

        window.removeEventListener('resize', this.resizeWindow);
    }
    resizeWindow = () => {
        let windowWidth = this.state.windowWidth;
        let windowHeight = this.state.windowHeight;
        if (typeof window != 'undefined' && window.innerWidth && Math.abs(windowWidth - window.innerWidth) > 50) {
            this.setState({ windowWidth: window.innerWidth })
        } else if (typeof window != 'undefined' && window.innerHeight && Math.abs(windowHeight - window.innerHeight) > 50) {
            this.setState({ windowHeight: window.innerHeight })
        }

    }



    componentDidUpdate(prevProps, prevState) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }


        if (!prevProps.uData && this.props.uData) {
            this.setLastGroupAlias();
        }

        if (prevProps[0].location.pathname != this.props[0].location.pathname) {
            this.get();
        }

        if (typeof prevProps.selectedWaitingTimeType != 'undefined' && prevProps.selectedWaitingTimeType != this.props.selectedWaitingTimeType) {
            if (this.props.selectedWaitingTimeType == 0) {
                this.props.changeMinValue('');
                this.props.changeMaxValue('');
            } else if (this.props.selectedWaitingTimeType == 1) {
                this.props.changeMinValue(0);
                this.props.changeMaxValue(0);
            } else if (this.props.selectedWaitingTimeType == 2) {
                this.props.changeMinValue('');
                this.props.changeMaxValue(0);
            } else if (this.props.selectedWaitingTimeType == 3) {
                this.props.changeMinValue(0);
                this.props.changeMaxValue('');
            } else if (this.props.selectedWaitingTimeType == 4) {
                this.props.changeMinValue('');
                this.props.changeMaxValue('');
            } else if (this.props.selectedWaitingTimeType == 5) {
                this.props.changeMinValue('');
                this.props.changeMaxValue('');
            }
        }

        if (prevProps.uData != this.props.uData && this.props.uData && this.state.initialLanding) {
            this.setState({ initialLanding: false })
        }

        if (prevState.mainGroupLoginBankIdModal != this.state.mainGroupLoginBankIdModal && !this.state.mainGroupLoginBankIdModal && this.fetchMainClGroupBankIdLoginInterval) {
            clearTimeout(this.fetchMainClGroupBankIdLoginInterval)
        }


        if (typeof window != 'undefined' && !localStorage.groupAlias && this.props[0].match.params.alias) {
            localStorage.groupAlias = this.props[0].match.params.alias;
        }

        if (prevProps?.uData?._id !== this.props.uData?._id || prevState?.data?._id !== this.state.data?._id || prevProps?.[0]?.match?.params?.alias !== this.props?.[0]?.match?.params?.alias) {
            this.checkUserAuth();
        }
    }



    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, [{ name: 'sortField', value: field }, { name: 'sortType', value: type }], false));

        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0 }, name, value, restart));
        }
    }
    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, fields, restart));
        }
    }
    checkDropInForms = () => {
        let alias = this.props[0].match.params.alias;
        fetch(API_ENDPOINT + '/clinicGroup/check/drop-in/forms', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ alias })
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                this.props[0].history.push(`/`);

            } else if (result && result.availableTerms) {
                this.setState({
                    checkWorkingHoursError: 'We are currently unable to accept your drop in referral. Please try again later within the enclosed working hours'.translate(this.props.lang),
                    checkWorkingHoursAvailableTerms: result.availableTerms
                })
            } else if (result && result.dropInForms && result.dropInForms.length) {
                this.setState({
                    dropInForms: result.dropInForms,
                    hideSearchField: result.hideSearchField,
                    selectedDropInForm: null,
                    dropInFormsSelectOpen: true
                })
            } else {
                this.setState({
                    infoMessage: 'There is no active Drop-in form'.translate(this.props.lang)
                })
            }
        });
    }
    checkDepartments = (clinic) => {
        let alias = this.props[0].match.params.alias;

        if (clinic) {
            this.setState({ clinicsForSelect: null, clinicSelectOpen: null })
        }

        fetch(API_ENDPOINT + '/clinicGroup/check/departments', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ alias, clinic })
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                this.props[0].history.push(`/`);

            } else if (result.canCreateDropIn) {
                fetch(API_ENDPOINT + '/referrals/check/estimated/time', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        alias: localStorage.getItem('groupAlias'),
                        clinic: clinic

                    })
                }).then(parseJSON).then(({ result, status }) => {
                    if (result) {
                        if (result.estimatedTime > 0 && this.state.dropInForms) {
                            this.setState({
                                estimatedWaitingTime: result.estimatedTime
                            }, () => {
                                this.forceUpdate()
                            })
                        } else {
                            this.continueDropIn()
                        }


                    }

                })

            } else if (result.canCreateDropIn === false) {
                this.setState({
                    checkWorkingHoursError: 'We are currently unable to accept your drop in referral. Please try again later within the enclosed working hours'.translate(this.props.lang),
                    checkWorkingHoursAvailableTerms: result.availableTerms
                })
            } else if (result.clinics && result.clinics.length) {
                this.setState({
                    clinicsForSelect: result.clinics,
                    selectedClinic: result.clinics[0]._id,
                    clinicSelectOpen: true
                })
            }
        });



    }

    webBookingCheck = () => {
        let alias = this.props[0].match.params.alias;

        fetch(API_ENDPOINT + '/clinicGroup/check/webbooking', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ alias })
        }).then(res => res.json()).then((result) => {

            if (result.error) {
                this.props[0].history.push(`/`);

            } else if (result.canCreateWebBooking) {
                if (this.props[0].match.params.mainAlias) {
                    fetch(API_ENDPOINT + '/data/without-token/professions/all/' + this.props[0].match.params.alias, {
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            isDropIn: false,
                            uid: this.props.uData && this.props.uData._id ? this.props.uData._id : null
                        })
                    }).then(res => res.json()).then((result) => {
                        if (result) {
                            let availableProfessions = [];
                            for (let i = 0; i < result.length; i++) {
                                availableProfessions.push({
                                    name: this.props.lang == 'en' ? result[i].professionEn : result[i].professionSv,
                                    value: result[i]._id
                                })
                            }
                            this.setState({ availableProfessions }, () => this.getPersonalQuestionaries())
                        }
                    })
                } else {
                    fetch(API_ENDPOINT + '/data/without-token/professions/all/' + this.props[0].match.params.alias, {
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            isDropIn: false,
                            uid: this.props.uData && this.props.uData._id ? this.props.uData._id : null
                        })
                    }).then(res => res.json()).then((result) => {
                        if (result) {
                            let availableProfessions = [];
                            for (let i = 0; i < result.length; i++) {
                                availableProfessions.push({
                                    name: this.props.lang == 'en' ? result[i].professionEn : result[i].professionSv,
                                    value: result[i]._id
                                })
                            }

                            this.setState({ availableProfessions }, () => this.getPersonalQuestionaries())

                        }



                    })
                }
            } else if (result.canCreateWebBooking === false) {
                this.setState({
                    checkWebBookingError: 'There are no available times to book.'.translate(this.props.lang),
                })
            }
        });



    }

    openCalendar = () => {
        if (this.props[0].match.params.mainAlias) {
            this.props[0].history.push({
                pathname: `/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/choose-time`,
                state: {
                    selectedReferral: this.state.selectedReferral,
                    referral: this.state.referral,
                    clinicGroup: this.state.clinicGroup
                }
            })
        } else {

            this.props[0].history.push({
                pathname: `/${this.props[0].match.params.alias}/choose-time`,
                state: {
                    selectedReferral: this.state.selectedReferral,
                    referral: this.state.referral,
                    clinicGroup: this.state.clinicGroup
                }
            })
        }
    }

    getPersonalQuestionaries = () => {
        if (!this.state.availableProfessions || (this.state.availableProfessions && this.state.availableProfessions.length == 0)) {
            this.setState({ referrals: [] })
        } else {
            fetch(API_ENDPOINT + '/data/without-token/personal-questionary/all/' + this.props[0].match.params.alias, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    availableProfessions: this.state.availableProfessions,
                    page: this.state.page,
                    filter: this.state.searchQuestionaries ? this.state.searchQuestionaries : '',
                })
            }).then(res => res.json()).then((result) => {
                if (result.clinicGroup) {
                    this.setState({ clinicGroup: result.clinicGroup })
                }
                if (result.referrals) {
                    this.setState({ referrals: result.referrals }, this.checkSearchedReferrals)
                }
                if (result.total) {
                    this.setState({ total: result.total })
                } else {
                    this.setState({ total: 0 })
                }

            })

        }
    }
    checkSearchedReferrals = () => {
        let searchedReferrals = []
        if (this.state.referrals && this.state.referrals.length) {
            for (let i = 0; i < this.state.referrals.length; i++) {
                if (this.state.searchQuestionaries) {
                    let name = this.state.referrals[i].name;
                    let anotherName = this.state.referrals[i].anotherName;
                    name = name.toLowerCase()
                    anotherName = anotherName.toLowerCase()
                    let searchQuestionaries = this.state.searchQuestionaries;
                    searchQuestionaries = searchQuestionaries.toLowerCase()
                    if ((name.indexOf(searchQuestionaries) != -1 || anotherName.indexOf(searchQuestionaries) != -1) && searchedReferrals.filter(el => el._id == this.state.referrals[i]._id).length == 0)
                        searchedReferrals.push(this.state.referrals[i])
                } else if (searchedReferrals.filter(el => el._id == this.state.referrals[i]._id).length == 0) {
                    searchedReferrals.push(this.state.referrals[i])
                }

            }
        }
        this.setState({ searchedReferrals })
    }
    continueDropIn = () => {
        if (this.props.uData) {
            this.props.registerClinicGroupLogs({
                type: 'startCreateReferral',
                referralType: 'Drop in',
                questionaryId: this.state.selectedDropInForm
            })
            if (this.props[0].match.params.mainAlias) {

                this.props[0].history.push({
                    pathname: `/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/drop-in`,
                    state: { isDropIn: true, selectedDropInForm: this.state.selectedDropInForm }
                })
            } else {
                this.props[0].history.push({
                    pathname: `/${this.props[0].match.params.alias}/drop-in`,
                    state: { isDropIn: true, selectedDropInForm: this.state.selectedDropInForm }
                })
            }


        } else {

            this.setState({
                bankIdModalDropIn: true
            }, () => {

                this.fetchBankIdDropIn()
            })

        }
    }

    fetchBankIdDropIn = () => {

        this.setState({
            bankIdModalDropIn: true
        })
    }
    fetchBankIdLogin = () => {

        this.setState({
            loginBankIdModal: true
        })

    }
    fetchMainClGroupBankIdLogin = () => {

        this.setState({
            mainGroupLoginBankIdModal: true
        })

    }
    fetchBankId1 = () => {

        this.setState({
            bankIdModal1: true
        })

    }


    fetchBankId = () => {

        this.setState({
            bankIdModal: true
        })
    }
    fetchBankIdDaybook = () => {


        this.setState({
            bankIdModalDaybook: true
        })

    }








    setLocalStorageGroupAlias = () => {
        let alias;
        if (this.props[0].match.params.alias) {
            alias = this.props[0].match.params.alias;
        }
        if (alias && typeof window != 'undefined') {
            localStorage.groupAlias = alias;
        }
    }

    open2FAModal = (userId, secretKey, alias) => {
        if (this.state.ignore2faLink) return;
        this.setState({
            userVerificationData: {
                userId,
                secretKey,
                alias,
            }
        }, () => {
            console.log(this.state.userVerificationData)
        });
    }

    close2FAModal = () => this.setState({ userVerificationData: null, uid: null, show2FAModal: false, ignore2faLink: true }, () => {
        try {
            const url = new URL(window.location.href);
            if (url) {
                const userId = url.searchParams.get('user_id');
                const secretKey = url.searchParams.get('secret_key');
                if (userId && secretKey) {
                    url.searchParams.delete('user_id');
                    url.searchParams.delete('secret_key');
                    window.history.replaceState({}, document.title, url.toString());
                }
            }
        } catch (err) { }
    });

    login2FA = (result) => {
        if (result && result.token) {
            try {
                if (result?.userData && typeof window !== 'undefined') {
                    localStorage?.setItem?.('userData', JSON.stringify(result?.userData));
                }
            } catch (err) {
                console.error('login user data err: ', err);
            }

            if (window?.top) window.top.postMessage('loggedin', '*');

            localStorage?.setItem('authToken', result.token);
            localStorage?.setItem('time', Math.floor(Date.now() / 1000))
            localStorage?.setItem('profile', 'patient');
            localStorage?.setItem('2faLogin', 'true');

            const alias = this.props[0].match.params.alias;
            if (alias) {
                localStorage?.setItem('groupAlias', alias);
                localStorage?.setItem('logoutLandingPage', true);
                localStorage?.setItem('loginGroupAlias', alias);
            }

            this.props?.verifyUser?.(() => {
                if (this.state.navigateToMyChildren && (this.props?.uData?.userLevel == 2 || (this.props?.uData?.userLevel == 20 && typeof window !== 'undefined' && localStorage?.getItem?.('profile') == 'patient'))) {
                    // Nothing
                } else {
                    this.close2FAModal();

                };

            }, null, null, () => {
                if (this.state.navigateToMyChildren && (this.props?.uData?.userLevel == 2 || (this.props?.uData?.userLevel == 20 && typeof window !== 'undefined' && localStorage?.getItem?.('profile') == 'patient'))) {
                    this.props?.[0]?.history?.push?.(
                        '/my-data/account',
                        { navigateToMyChildren: true }
                    );
                } else {
                    this.close2FAModal();

                };
            });
        }
    }

    checkUserAuth = () => {
        const user = this.props.uData;
        const groupId = this.state.data?._id;
        const loggedInWith2fa = localStorage?.getItem?.('2faLogin');

        if (loggedInWith2fa && loggedInWith2fa === 'true' && user && groupId) {
            this.setState({ loading: true }, async () => {
                const newState = {
                    loading: false,
                };

                const response = await fetch(API_ENDPOINT + '/users/two-factor-auth/check-clinic-group', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                    },
                    body: JSON.stringify({ groupId })
                });

                const result = await response?.json?.();

                if (!result) return this.setState(newState);

                if (result.error) {
                    newState.twoFactorAuthForbidden = result.error;
                    this.setState(newState);
                } else {
                    newState.twoFactorAuthForbidden = false;
                    this.setState(newState);
                }

                if (result.verify && result.verify === true) this.props.verifyUser?.();
            });
        }
    }

    navigateBackToProfile = () => {
        this.setState({ twoFactorAuthForbidden: false }, () => {
            this.props?.[0]?.history?.replace?.('/my-data/account');
        });
    }

    render() {
        if (this.state.notAuthorized) {
            return (
                <>
                    <InfoModal
                        isOpen={true}
                        close={true}
                        header={'Info'.translate(this.props.lang)}
                        info={'You are not authorized to view this page. Please log in first.'.translate(this.props.lang)}
                        buttons={[
                            <Button color="primary" style={{ margin: 10 }} onClick={() => {
                                const alias = this.props[0].match.params.alias;
                                if (alias) {
                                    this.props[0].history.push(`/${alias}`);
                                }
                            }}>{'Ok'.translate(this.props.lang)}</Button>,



                        ]}
                    />
                </>
            )
        }
        if (!this.state.data) {
            return null;
        }
        if (typeof window == 'undefined')
            return null;



        let backToMain = 'Back to main clinic group'.translate(this.props.lang);
        if (this.state.data && this.state.data.backToMain) {
            if (this.props.lang == 'en' && this.state.data.backToMain.backToMainEn) {
                backToMain = this.state.data.backToMain.backToMainEn;
            } else if (this.props.lang == 'se' && this.state.data.backToMain.backToMainSv) {
                backToMain = this.state.data.backToMain.backToMainSv;
            }
        }

        let maxHeight = typeof window !== 'undefined' && document.getElementById('main-container')?.offsetHeight;
        let shameStyle = this.state.selectdLandingConfig && this.state.data.footerBackground ? { backgroundColor: this.state.data.footerBackground } : {}
        if (maxHeight) {
            shameStyle.overflow = 'hidden';
        }


        const landingStyle = this.state?.infoPageData?.landingStyle ?? null;
        const allowedLinks = !this.state?.infoPageData?.isPrivate ? 'all' : this.state?.infoPageData?.allowedLinks ?? null;
        return (

            <div className={this.state.data.mainClinicGroup ? "shame shame-overflow-h" : "shame"} style={shameStyle}>
                {/* {
                    this.props[0].match.params.mainAlias ?
                        <div className='landing-back-to-main-group-wrap'>
                            <div className='landing-back-to-main-group' onClick={() => {
                                this.props[0].history.push({ pathname: `/${this.props[0].match.params.mainAlias}`, state: { initialLanding: false } })
                            }}>
                                <Isvg src={arrowLeftIcon} /> {backToMain}
                            </div>
                        </div>
                        :
                        null

                } */}

                {this.state.estimatedWaitingTime ?
                    <InfoModal
                        isOpen={this.state.estimatedWaitingTime}

                        close={true}
                        header={'Info'.translate(this.props.lang)}
                        info={'Estimated waiting time is'.translate(this.props.lang) + ' ' + (this.state.estimatedWaitingTime ? parseInt(this.state.estimatedWaitingTime / 60) == 0 ? this.state.estimatedWaitingTime + ' ' + 'minutes'.translate(this.props.lang) : + parseInt(this.state.estimatedWaitingTime / 60) + 'h'.translate(this.props.lang) + ' ' + 'and'.translate(this.props.lang) + ' ' + this.state.estimatedWaitingTime % 60 + ' ' + 'minutes'.translate(this.props.lang) : '/')}
                        buttons={[
                            <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ estimatedWaitingTime: null }, () => {
                                this.continueDropIn()
                            })}>{'Continue'.translate(this.props.lang)}</Button>,
                            <Button color="primary" style={{ margin: 10 }} onClick={() => {

                            }}>{'Cancel'.translate(this.props.lang)}</Button>


                        ]}
                    />
                    : null}

                {
                    this.state.clinicsForSelect ?
                        <Modal isOpen={this.state.clinicSelectOpen} centered>
                            <ModalHeader style={{ display: 'flex', justifyContent: 'center' }}>
                                {'Select department'.translate(this.props.lang)}
                            </ModalHeader>
                            <ModalBody className="delete-modal">
                                <Input type='select' value={this.state.selectedClinic} onChange={(e) => {
                                    this.setState({ selectedClinic: e.target.value })
                                }}>
                                    {
                                        this.state.clinicsForSelect.map((item, idx) => {
                                            return (
                                                <option value={item._id}>{item.name}, {item.subgroupName}</option>
                                            )
                                        })
                                    }
                                </Input>
                            </ModalBody>
                            <ModalFooter style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button color='primary' onClick={() => {
                                    this.checkDepartments(this.state.selectedClinic)
                                }}>{'Ok'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.dropInForms ?
                        <Modal isOpen={this.state.dropInFormsSelectOpen} centered>
                            <ModalHeader style={{ display: 'flex', justifyContent: 'center' }}>
                                {'What do you need help with?'.translate(this.props.lang)}
                            </ModalHeader>
                            <ModalBody className="delete-modal">
                                <CustomSelectWithSearch
                                    isInputClearable={true}
                                    lang={this.props.lang}
                                    items={this.state.dropInForms.map((item, idx) => {
                                        return {
                                            name: item.name,
                                            value: item._id
                                        }
                                    })}
                                    value={this.state.selectedDropInForm}
                                    hideSearchField={this.state.hideSearchField}
                                    maxHeight={'50vh'}
                                    onChange={(e) => {
                                        if (e && e.value && this.state.dropInForms.filter(item => item._id === e.value).length) {
                                            this.setState({ selectedDropInForm: e.value }, () => {
                                                let clinic;
                                                if (this.state.dropInForms && this.state.dropInForms.filter(item => item._id == this.state.selectedDropInForm).length) {
                                                    clinic = this.state.dropInForms.filter(item => item._id == this.state.selectedDropInForm)[0].clinic;
                                                }
                                                if (clinic) {
                                                    this.checkDepartments(clinic)
                                                }
                                            })
                                        } else {
                                            this.setState({ selectedDropInForm: null })
                                        }


                                    }}
                                />

                            </ModalBody>
                            <ModalFooter style={{ display: 'flex', justifyContent: 'center' }} className='buttons-right-blue'>

                                <Button color='primary' onClick={() => {
                                    this.setState({ dropInFormsSelectOpen: false })
                                }}>{'Cancel'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.infoMessage ?
                        <InfoModal
                            isOpen={this.state.infoMessage}
                            onClose={(item) => {
                                this.setState({
                                    infoMessage: item
                                })
                            }}
                            close={true}
                            header={'Info'.translate(this.props.lang)}
                            info={this.state.infoMessage}
                            buttons={[
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ infoMessage: false }, () => {

                                }
                                )}>{'Ok'.translate(this.props.lang)}</Button>,

                            ]}
                        />
                        :
                        null
                }

                {
                    this.state.checkWebBookingError ?
                        <InfoModal
                            isOpen={this.state.checkWebBookingError}
                            onClose={(item) => {
                                this.setState({
                                    checkWebBookingError: item
                                })
                            }}
                            close={true}
                            header={'Info'.translate(this.props.lang)}
                            info={this.state.checkWebBookingError}
                            buttons={[
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ checkWebBookingError: false }, () => {

                                }
                                )}>{'Go back'.translate(this.props.lang)}</Button>,

                            ]}
                        />
                        :
                        null
                }

                {
                    this.state.checkWorkingHoursError ?
                        <InfoModal
                            isOpen={this.state.checkWorkingHoursError}
                            onClose={(item) => {
                                this.setState({
                                    checkWorkingHoursError: item
                                })
                            }}
                            close={true}
                            header={'Info'.translate(this.props.lang)}
                            info={
                                <>
                                    <span style={{ fontWeight: 600 }}>{this.state.checkWorkingHoursError}</span>
                                    <div className='table-error-dropin'>
                                        {
                                            this.state.checkWorkingHoursAvailableTerms && this.state.checkWorkingHoursAvailableTerms.map((item, idx) => {
                                                const startTime = this.props.getStringDate(item.startTimeUTC, 'HH:mm');
                                                // console.log(idx, startTime, item.startTimeUTC);
                                                const endTime = this.props.getStringDate(item.endTimeUTC, 'HH:mm');
                                                const timeUTC = `${startTime} - ${endTime}`
                                                return (


                                                    idx == 0 ?
                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>{'Monday'.translate(this.props.lang).toUpperCase()}: <span>{item.available ? timeUTC : 'Closed'.translate(this.props.lang)}</span></div>
                                                        :
                                                        idx == 1 ?
                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>{'Tuesday'.translate(this.props.lang).toUpperCase()}: <span>{item.available ? timeUTC : 'Closed'.translate(this.props.lang)}</span></div>
                                                            :
                                                            idx == 2 ?
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>{'Wednesday'.translate(this.props.lang).toUpperCase()}: <span>{item.available ? timeUTC : 'Closed'.translate(this.props.lang)}</span></div>
                                                                :
                                                                idx == 3 ?
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>{'Thursday'.translate(this.props.lang).toUpperCase()}: <span>{item.available ? timeUTC : 'Closed'.translate(this.props.lang)}</span></div>
                                                                    :
                                                                    idx == 4 ?
                                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>{'Friday'.translate(this.props.lang).toUpperCase()}: <span>{item.available ? timeUTC : 'Closed'.translate(this.props.lang)}</span></div>
                                                                        :
                                                                        idx == 5 ?
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>{'Saturday'.translate(this.props.lang).toUpperCase()}: <span>{item.available ? timeUTC : 'Closed'.translate(this.props.lang)}</span></div>
                                                                            :
                                                                            idx == 6 ?
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>{'Sunday'.translate(this.props.lang).toUpperCase()}: <span>{item.available ? timeUTC : 'Closed'.translate(this.props.lang)}</span></div>
                                                                                :
                                                                                null


                                                )
                                            })
                                        }
                                    </div>
                                </>

                            }
                            buttons={[
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ checkWorkingHoursError: false }, () => {
                                    this.props[0].history.push(`/${this.props[0].match.params.alias}`)
                                })}>{'Ok'.translate(this.props.lang)}</Button>,

                            ]}
                        />
                        :
                        null
                }
                {this.state.error ? null :
                    <Container fluid id="main-container" style={this.state.landingBackgroundColor ? { height: '100%', backgroundColor: this.state.landingBackgroundColor } : { height: '100%', backgroundColor: 'white' }}>
                        <Row className={!this.props[0].match.params.mainAlias ? "main-container-wrap" : "main-container-wrap-v2"}>
                            <Col lg="12" className="p-0" style={{ display: 'flex', flexDirection: 'column' }}>
                                <div className="landing-page-container">
                                    {
                                        typeof window != 'undefined' && window.innerWidth > 480 ?


                                            <div style={{ marginTop: this.props.uData && typeof window != 'undefined' && window.innerWidth < 1200 ? 70 : 0 }}>

                                                {
                                                    !this.state.data.mainClinicGroup ?
                                                        <div className='landing-header' style={this.state.data?.headerSettings?.backgroundColor ? { backgroundColor: this.state.data.headerSettings.backgroundColor } : {}} >
                                                            {
                                                                !this.state.data.mainClinicGroup || (this.state.data.mainClinicGroup && this.state.data.showHeader) ?
                                                                    <Container>
                                                                        <Row>
                                                                            <Col lg="12">
                                                                                <div className="login-header">


                                                                                    <div className="logo">
                                                                                        <img src={API_ENDPOINT + this.state.data.logo} className="landing-page-logo" />
                                                                                    </div>


                                                                                    <div className="navigation">
                                                                                        {
                                                                                            this.state.data && !this.state.data.mainClinicGroup ?
                                                                                                <>
                                                                                                    {this.props.uData ?
                                                                                                        <div>
                                                                                                            <span className="username">{this.props.uData.userData.name}</span>
                                                                                                            <button className={'login-button-landing-page'} style={this.state.data.loginOutline ? { backgroundColor: 'transparent', border: `1px solid ${this.state.data.loginColor}`, color: this.state.data.loginColor } : { background: this.state.data.loginColor, border: `1px solid transparent`, color: 'white' }}
                                                                                                                onMouseEnter={() => {
                                                                                                                    let data = this.state.data;
                                                                                                                    data.loginOutline = !this.state.data.loginOutline
                                                                                                                    this.setState({
                                                                                                                        data
                                                                                                                    })
                                                                                                                }}
                                                                                                                onMouseLeave={() => {
                                                                                                                    let data = this.state.data;
                                                                                                                    data.loginOutline = !this.state.data.loginOutline
                                                                                                                    this.setState({
                                                                                                                        data
                                                                                                                    })
                                                                                                                }}
                                                                                                                onClick={() => this.props.signOut()}>{'Logout'.translate(this.props.lang)}</button>
                                                                                                        </div>
                                                                                                        :
                                                                                                        <button className={'login-button-landing-page'} style={this.state.data.loginOutline ? { backgroundColor: 'transparent', border: `1px solid ${this.state.data.loginColor}`, color: this.state.data.loginColor } : { background: this.state.data.loginColor, border: `1px solid transparent`, color: 'white' }}
                                                                                                            onMouseEnter={() => {
                                                                                                                let data = this.state.data;
                                                                                                                data.loginOutline = !this.state.data.loginOutline
                                                                                                                this.setState({
                                                                                                                    data
                                                                                                                })
                                                                                                            }}
                                                                                                            onMouseLeave={() => {
                                                                                                                let data = this.state.data;
                                                                                                                data.loginOutline = !this.state.data.loginOutline
                                                                                                                this.setState({
                                                                                                                    data
                                                                                                                })
                                                                                                            }}
                                                                                                            onClick={() => {
                                                                                                                this.setState({
                                                                                                                    loginBankIdModal: true
                                                                                                                }, () => {

                                                                                                                })

                                                                                                            }}>{'Login'.translate(this.props.lang)}</button>
                                                                                                    }
                                                                                                </>
                                                                                                :
                                                                                                null
                                                                                        }

                                                                                    </div>
                                                                                </div>

                                                                            </Col>
                                                                        </Row>


                                                                    </Container>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        :
                                                        null
                                                }




                                            </div>



                                            :
                                            null
                                    }
                                </div>


                                {/* Landing style v2 */}
                                <div>
                                    {
                                        typeof window != 'undefined' && window.innerWidth < 480 ?
                                            landingStyle ?
                                                <div style={{ marginTop: this.props.uData ? 70 : 0 }}>
                                                    <JsonToHtmlV2
                                                        allowedGumletLinks={allowedLinks}
                                                        layout={'xs'}
                                                        nodes={JSON.parse(JSON.stringify(landingStyle))}
                                                        uData={this.props.uData}
                                                        getSelectedItem={(item) => {
                                                            this.setState({ selectdLandingConfig: item })
                                                        }}
                                                        {...this.props}
                                                        data={this.state.data}
                                                        dropInButtonShow={this.state.data.dropInButtonShow}
                                                        lastVisitedClinics={this.state.lastVisitedClinics}
                                                        loginHandler={() => {
                                                            if (!this.props.uData) {
                                                                this.setState({
                                                                    loginBankIdModal: true
                                                                }, () => {

                                                                    this.fetchBankIdLogin()
                                                                })
                                                            }
                                                        }}
                                                        loginBtn={() => {
                                                            if (!this.props.uData) {
                                                                this.setState({
                                                                    loginBankIdModal: true
                                                                }, () => {
                                                                    this.fetchBankIdLogin()
                                                                })
                                                            } else {
                                                                this.props.signOut()
                                                            }

                                                        }}
                                                        myReferralHandler={() => {
                                                            if (this.props.uData) {
                                                                if (!this.props.uData.haveReferrals && !this.props.uData.havePersonalReferrals) {
                                                                    this.setState({
                                                                        error: 'You have no active issues with us...'.translate(this.props.lang),
                                                                        bankIdModal1: null
                                                                    })
                                                                    return;
                                                                }
                                                                this.props[0].history.push(`/my-data/personal-referrals/referrals`)
                                                            } else {
                                                                this.setState({
                                                                    bankIdModal1: true
                                                                }, () => {
                                                                    this.fetchBankId1()
                                                                })
                                                            }
                                                        }}
                                                        loginBankId={() => {
                                                            this.setState({
                                                                mainGroupLoginBankIdModal: true
                                                            }, () => {


                                                                this.fetchMainClGroupBankIdLogin()
                                                            })
                                                        }}
                                                        informationHandler={() => {
                                                            if (this.state.data.informationLink && this.state.data.informationLink != '')
                                                                window.open(this.state.data.informationLink, '_blank');
                                                            else {
                                                                if (this.props[0].match.params.mainAlias) {
                                                                    window.open(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/information`, '_blank');
                                                                } else {
                                                                    window.open(`/${this.props[0].match.params.alias}/information`, '_blank');
                                                                }
                                                            }

                                                        }}
                                                        seekCareHandler={() => {
                                                            if (this.props.uData) {
                                                                if (this.props[0].match.params.mainAlias) {
                                                                    this.props[0].history.push(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/personal-referral`)
                                                                } else {
                                                                    this.props[0].history.push(`/${this.props[0].match.params.alias}/personal-referral`)
                                                                }
                                                            } else {
                                                                this.setState({
                                                                    bankIdModal: true
                                                                }, () => {
                                                                    this.fetchBankId()
                                                                })
                                                            }
                                                        }}
                                                        daybookHandler={() => {
                                                            this.setLocalStorageGroupAlias();
                                                            if (this.props.uData) {

                                                                this.props[0].history.push({
                                                                    pathname: `/my-data/account`,
                                                                    state: { tabIndex: 2 }
                                                                })
                                                            } else {
                                                                this.setState({
                                                                    bankIdModalDaybook: true
                                                                }, () => {
                                                                    this.fetchBankIdDaybook()
                                                                })
                                                            }
                                                        }}
                                                        dropInHandler={() => {

                                                            this.checkDropInForms();
                                                        }}
                                                        chooseTimeHandle={() => {
                                                            this.webBookingCheck()
                                                        }}

                                                        waitingRoomHandler={() => {
                                                            if (this.props.uData) {

                                                                this.props[0].history.push(`/waiting-room`)
                                                            } else {
                                                                this.setState({
                                                                    bankIdModalWaitingRoom: true
                                                                })
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                :
                                                <div style={{ marginTop: this.props.uData ? 70 : 0 }}>
                                                    <JsonToHtmlV2
                                                        allowedGumletLinks={allowedLinks}
                                                        layout={'xs'}
                                                        nodes={JSON.parse(JSON.stringify(defaultInfoPages))}
                                                        uData={this.props.uData}
                                                        loginBankId={() => {
                                                            this.setState({
                                                                mainGroupLoginBankIdModal: true
                                                            }, () => {


                                                                this.fetchMainClGroupBankIdLogin()
                                                            })
                                                        }}
                                                        loginHandler={() => {
                                                            if (!this.props.uData) {
                                                                this.setState({
                                                                    loginBankIdModal: true
                                                                }, () => {

                                                                    this.fetchBankIdLogin()
                                                                })
                                                            }
                                                        }}
                                                        lastVisitedClinics={this.state.lastVisitedClinics}
                                                        getSelectedItem={(item) => {
                                                            this.setState({ selectdLandingConfig: item })
                                                        }}
                                                        {...this.props}
                                                        data={this.state.data}
                                                        dropInButtonShow={this.state.data.dropInButtonShow}
                                                        loginBtn={() => {
                                                            if (!this.props.uData) {
                                                                this.setState({
                                                                    loginBankIdModal: true
                                                                }, () => {
                                                                    this.fetchBankIdLogin()
                                                                })
                                                            } else {
                                                                this.props.signOut()
                                                            }

                                                        }}
                                                        myReferralHandler={() => {
                                                            if (this.props.uData) {
                                                                if (!this.props.uData.haveReferrals && !this.props.uData.havePersonalReferrals) {
                                                                    this.setState({
                                                                        error: 'You have no active issues with us...'.translate(this.props.lang),
                                                                        bankIdModal1: null
                                                                    })
                                                                    return;
                                                                }
                                                                this.props[0].history.push(`/my-data/personal-referrals/referrals`)
                                                            } else {
                                                                this.setState({
                                                                    bankIdModal1: true
                                                                }, () => {
                                                                    this.fetchBankId1()
                                                                })
                                                            }
                                                        }}
                                                        informationHandler={() => {
                                                            if (this.state.data.informationLink && this.state.data.informationLink != '')
                                                                window.open(this.state.data.informationLink, '_blank');
                                                            else {
                                                                if (this.props[0].match.params.mainAlias) {
                                                                    window.open(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/information`, '_blank');
                                                                } else {
                                                                    window.open(`/${this.props[0].match.params.alias}/information`, '_blank');
                                                                }
                                                            }
                                                        }}
                                                        seekCareHandler={() => {
                                                            if (this.props.uData) {
                                                                if (this.props[0].match.params.mainAlias) {
                                                                    this.props[0].history.push(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/personal-referral`)
                                                                } else {
                                                                    this.props[0].history.push(`/${this.props[0].match.params.alias}/personal-referral`)
                                                                }
                                                            } else {
                                                                this.setState({
                                                                    bankIdModal: true
                                                                }, () => {
                                                                    this.fetchBankId()
                                                                })
                                                            }
                                                        }}
                                                        daybookHandler={() => {
                                                            this.setLocalStorageGroupAlias();
                                                            if (this.props.uData) {

                                                                this.props[0].history.push({
                                                                    pathname: `/my-data/account`,
                                                                    state: { tabIndex: 2 }
                                                                })
                                                            } else {
                                                                this.setState({
                                                                    bankIdModalDaybook: true
                                                                }, () => {
                                                                    this.fetchBankIdDaybook()
                                                                })
                                                            }
                                                        }}
                                                        dropInHandler={() => {

                                                            this.checkDropInForms();
                                                        }}
                                                        chooseTimeHandle={() => {
                                                            this.webBookingCheck()
                                                        }}

                                                        waitingRoomHandler={() => {
                                                            if (this.props.uData) {

                                                                this.props[0].history.push(`/waiting-room`)
                                                            } else {
                                                                this.setState({
                                                                    bankIdModalWaitingRoom: true
                                                                })
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            :
                                            typeof window != 'undefined' && window.innerWidth >= 480 && window.innerWidth < 1200 ?
                                                landingStyle ?
                                                    <div style={{ marginTop: this.props.uData ? 70 : 0 }}>
                                                        <JsonToHtmlV2
                                                            allowedGumletLinks={allowedLinks}
                                                            getSelectedItem={
                                                                (item) => {
                                                                    this.setState({ selectdLandingConfig: item })
                                                                }
                                                            }
                                                            layout={'sm'}
                                                            nodes={JSON.parse(JSON.stringify(landingStyle))}
                                                            loginBankId={() => {
                                                                this.setState({
                                                                    mainGroupLoginBankIdModal: true
                                                                }, () => {


                                                                    this.fetchMainClGroupBankIdLogin()
                                                                })
                                                            }}
                                                            lastVisitedClinics={this.state.lastVisitedClinics}
                                                            loginHandler={() => {
                                                                if (!this.props.uData) {
                                                                    this.setState({
                                                                        loginBankIdModal: true
                                                                    }, () => {

                                                                        this.fetchBankIdLogin()
                                                                    })
                                                                }
                                                            }}
                                                            uData={this.props.uData}
                                                            {...this.props}
                                                            data={this.state.data}
                                                            dropInButtonShow={this.state.data.dropInButtonShow}
                                                            loginBtn={() => {
                                                                if (!this.props.uData) {
                                                                    this.setState({
                                                                        loginBankIdModal: true
                                                                    }, () => {
                                                                        this.fetchBankIdLogin()
                                                                    })
                                                                } else {
                                                                    this.props.signOut()
                                                                }

                                                            }}
                                                            myReferralHandler={() => {
                                                                if (this.props.uData) {
                                                                    if (!this.props.uData.haveReferrals && !this.props.uData.havePersonalReferrals) {
                                                                        this.setState({
                                                                            error: 'You have no active issues with us...'.translate(this.props.lang),
                                                                            bankIdModal1: null
                                                                        })
                                                                        return;
                                                                    }
                                                                    this.props[0].history.push(`/my-data/personal-referrals/referrals`)
                                                                } else {
                                                                    this.setState({
                                                                        bankIdModal1: true
                                                                    }, () => {
                                                                        this.fetchBankId1()
                                                                    })
                                                                }
                                                            }}
                                                            informationHandler={() => {
                                                                if (this.state.data.informationLink && this.state.data.informationLink != '')
                                                                    window.open(this.state.data.informationLink, '_blank');
                                                                else {
                                                                    if (this.props[0].match.params.mainAlias) {
                                                                        window.open(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/information`, '_blank');
                                                                    } else {
                                                                        window.open(`/${this.props[0].match.params.alias}/information`, '_blank');
                                                                    }
                                                                }
                                                            }}
                                                            seekCareHandler={() => {
                                                                if (this.props.uData) {
                                                                    if (this.props[0].match.params.mainAlias) {
                                                                        this.props[0].history.push(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/personal-referral`)
                                                                    } else {
                                                                        this.props[0].history.push(`/${this.props[0].match.params.alias}/personal-referral`)
                                                                    }
                                                                } else {
                                                                    this.setState({
                                                                        bankIdModal: true
                                                                    }, () => {
                                                                        this.fetchBankId()
                                                                    })
                                                                }
                                                            }}
                                                            daybookHandler={() => {
                                                                this.setLocalStorageGroupAlias();
                                                                if (this.props.uData) {
                                                                    this.props[0].history.push({
                                                                        pathname: `/my-data/account`,
                                                                        state: { tabIndex: 2 }
                                                                    })
                                                                } else {
                                                                    this.setState({
                                                                        bankIdModalDaybook: true
                                                                    }, () => {
                                                                        this.fetchBankIdDaybook()
                                                                    })
                                                                }
                                                            }}
                                                            dropInHandler={() => {
                                                                this.checkDropInForms();
                                                            }}
                                                            chooseTimeHandle={() => {
                                                                this.webBookingCheck()
                                                            }}

                                                            waitingRoomHandler={() => {
                                                                if (this.props.uData) {

                                                                    this.props[0].history.push(`/waiting-room`)
                                                                } else {
                                                                    this.setState({
                                                                        bankIdModalWaitingRoom: true
                                                                    })
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    :
                                                    <div style={{ marginTop: this.props.uData ? 70 : 0 }}>
                                                        <JsonToHtmlV2
                                                            allowedGumletLinks={allowedLinks}
                                                            layout={'sm'}
                                                            nodes={JSON.parse(JSON.stringify(defaultInfoPages))}
                                                            uData={this.props.uData}
                                                            loginBankId={() => {
                                                                this.setState({
                                                                    mainGroupLoginBankIdModal: true
                                                                }, () => {


                                                                    this.fetchMainClGroupBankIdLogin()
                                                                })
                                                            }}
                                                            loginHandler={() => {
                                                                if (!this.props.uData) {
                                                                    this.setState({
                                                                        loginBankIdModal: true
                                                                    }, () => {

                                                                        this.fetchBankIdLogin()
                                                                    })
                                                                }
                                                            }}
                                                            lastVisitedClinics={this.state.lastVisitedClinics}
                                                            getSelectedItem={(item) => {
                                                                this.setState({ selectdLandingConfig: item })
                                                            }}
                                                            {...this.props}
                                                            data={this.state.data}
                                                            dropInButtonShow={this.state.data.dropInButtonShow}
                                                            loginBtn={() => {
                                                                if (!this.props.uData) {
                                                                    this.setState({
                                                                        loginBankIdModal: true
                                                                    }, () => {
                                                                        this.fetchBankIdLogin()
                                                                    })
                                                                } else {
                                                                    this.props.signOut()
                                                                }

                                                            }}
                                                            myReferralHandler={() => {
                                                                if (this.props.uData) {
                                                                    if (!this.props.uData.haveReferrals && !this.props.uData.havePersonalReferrals) {
                                                                        this.setState({
                                                                            error: 'You have no active issues with us...'.translate(this.props.lang),
                                                                            bankIdModal1: null
                                                                        })
                                                                        return;
                                                                    }
                                                                    this.props[0].history.push(`/my-data/personal-referrals/referrals`)
                                                                } else {
                                                                    this.setState({
                                                                        bankIdModal1: true
                                                                    }, () => {
                                                                        this.fetchBankId1()
                                                                    })
                                                                }
                                                            }}
                                                            informationHandler={() => {
                                                                if (this.state.data.informationLink && this.state.data.informationLink != '')
                                                                    window.open(this.state.data.informationLink, '_blank');
                                                                else {
                                                                    if (this.props[0].match.params.mainAlias) {
                                                                        window.open(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/information`, '_blank');
                                                                    } else {
                                                                        window.open(`/${this.props[0].match.params.alias}/information`, '_blank');
                                                                    }
                                                                }
                                                            }}
                                                            seekCareHandler={() => {
                                                                if (this.props.uData) {
                                                                    if (this.props[0].match.params.mainAlias) {
                                                                        this.props[0].history.push(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/personal-referral`)
                                                                    } else {
                                                                        this.props[0].history.push(`/${this.props[0].match.params.alias}/personal-referral`)
                                                                    }
                                                                } else {
                                                                    this.setState({
                                                                        bankIdModal: true
                                                                    }, () => {
                                                                        this.fetchBankId()
                                                                    })
                                                                }
                                                            }}
                                                            daybookHandler={() => {
                                                                this.setLocalStorageGroupAlias();
                                                                if (this.props.uData) {
                                                                    this.props[0].history.push({
                                                                        pathname: `/my-data/account`,
                                                                        state: { tabIndex: 2 }
                                                                    })
                                                                } else {
                                                                    this.setState({
                                                                        bankIdModalDaybook: true
                                                                    }, () => {
                                                                        this.fetchBankIdDaybook()
                                                                    })
                                                                }
                                                            }}
                                                            dropInHandler={() => {
                                                                this.checkDropInForms();
                                                            }}
                                                            chooseTimeHandle={() => {
                                                                this.webBookingCheck()
                                                            }}

                                                            waitingRoomHandler={() => {
                                                                if (this.props.uData) {

                                                                    this.props[0].history.push(`/waiting-room`)
                                                                } else {
                                                                    this.setState({
                                                                        bankIdModalWaitingRoom: true
                                                                    })
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                :

                                                typeof window != 'undefined' && window.innerWidth >= 1200 && landingStyle ?
                                                    <JsonToHtmlV2
                                                        allowedGumletLinks={allowedLinks}
                                                        getSelectedItem={
                                                            (item) => {
                                                                this.setState({ selectdLandingConfig: item })
                                                            }
                                                        }
                                                        layout={'lg'}
                                                        nodes={JSON.parse(JSON.stringify(landingStyle))}
                                                        dropInButtonShow={this.state.data.dropInButtonShow}
                                                        {...this.props}
                                                        data={this.state.data}
                                                        loginBankId={() => {
                                                            this.setState({
                                                                mainGroupLoginBankIdModal: true
                                                            }, () => {


                                                                this.fetchMainClGroupBankIdLogin()
                                                            })
                                                        }}
                                                        lastVisitedClinics={this.state.lastVisitedClinics}
                                                        loginHandler={() => {
                                                            if (!this.props.uData) {
                                                                this.setState({
                                                                    loginBankIdModal: true
                                                                }, () => {

                                                                    this.fetchBankIdLogin()
                                                                })
                                                            }
                                                        }}
                                                        myReferralHandler={() => {
                                                            if (this.props.uData) {
                                                                if (!this.props.uData.haveReferrals && !this.props.uData.havePersonalReferrals) {
                                                                    this.setState({
                                                                        error: 'You have no active issues with us...'.translate(this.props.lang),
                                                                        bankIdModal1: null
                                                                    })
                                                                    return;
                                                                }
                                                                this.props[0].history.push(`/my-data/personal-referrals/referrals`)
                                                            } else {
                                                                this.setState({
                                                                    bankIdModal1: true
                                                                }, () => {
                                                                    this.fetchBankId1()
                                                                })
                                                            }
                                                        }}
                                                        informationHandler={() => {
                                                            if (this.state.data.informationLink && this.state.data.informationLink != '')
                                                                window.open(this.state.data.informationLink, '_blank');
                                                            else {
                                                                if (this.props[0].match.params.mainAlias) {
                                                                    window.open(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/information`, '_blank');
                                                                } else {
                                                                    window.open(`/${this.props[0].match.params.alias}/information`, '_blank');
                                                                }
                                                            }
                                                        }}
                                                        seekCareHandler={() => {
                                                            if (this.props.uData) {
                                                                if (this.props[0].match.params.mainAlias) {
                                                                    this.props[0].history.push(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/personal-referral`)
                                                                } else {
                                                                    this.props[0].history.push(`/${this.props[0].match.params.alias}/personal-referral`)
                                                                }
                                                            } else {
                                                                this.setState({
                                                                    bankIdModal: true
                                                                }, () => {
                                                                    this.fetchBankId()
                                                                })
                                                            }
                                                        }}
                                                        daybookHandler={() => {
                                                            this.setLocalStorageGroupAlias();
                                                            if (this.props.uData) {
                                                                this.props[0].history.push({
                                                                    pathname: `/my-data/account`,
                                                                    state: { tabIndex: 2 }
                                                                })
                                                            } else {
                                                                this.setState({
                                                                    bankIdModalDaybook: true
                                                                }, () => {
                                                                    this.fetchBankIdDaybook()
                                                                })
                                                            }
                                                        }}
                                                        dropInHandler={() => {
                                                            this.checkDropInForms();
                                                        }}
                                                        chooseTimeHandle={() => {
                                                            this.webBookingCheck()
                                                        }}

                                                        waitingRoomHandler={() => {
                                                            if (this.props.uData) {

                                                                this.props[0].history.push(`/waiting-room`)
                                                            } else {
                                                                this.setState({
                                                                    bankIdModalWaitingRoom: true
                                                                })
                                                            }
                                                        }}
                                                    />
                                                    :
                                                    <JsonToHtmlV2
                                                        allowedGumletLinks={allowedLinks}
                                                        layout={'lg'}
                                                        nodes={JSON.parse(JSON.stringify(defaultInfoPages))}
                                                        dropInButtonShow={this.state.data.dropInButtonShow}
                                                        loginBankId={() => {
                                                            this.setState({
                                                                mainGroupLoginBankIdModal: true
                                                            }, () => {


                                                                this.fetchMainClGroupBankIdLogin()
                                                            })
                                                        }}
                                                        lastVisitedClinics={this.state.lastVisitedClinics}
                                                        loginHandler={() => {
                                                            if (!this.props.uData) {
                                                                this.setState({
                                                                    loginBankIdModal: true
                                                                }, () => {

                                                                    this.fetchBankIdLogin()
                                                                })
                                                            }
                                                        }}
                                                        getSelectedItem={(item) => {
                                                            this.setState({ selectdLandingConfig: item })
                                                        }}
                                                        {...this.props}
                                                        data={this.state.data}
                                                        myReferralHandler={() => {
                                                            if (this.props.uData) {
                                                                if (!this.props.uData.haveReferrals && !this.props.uData.havePersonalReferrals) {
                                                                    this.setState({
                                                                        error: 'You have no active issues with us...'.translate(this.props.lang),
                                                                        bankIdModal1: null
                                                                    })
                                                                    return;
                                                                }
                                                                this.props[0].history.push(`/my-data/personal-referrals/referrals`)
                                                            } else {
                                                                this.setState({
                                                                    bankIdModal1: true
                                                                }, () => {
                                                                    this.fetchBankId1()
                                                                })
                                                            }
                                                        }}
                                                        informationHandler={() => {
                                                            if (this.state.data.informationLink && this.state.data.informationLink != '')
                                                                window.open(this.state.data.informationLink, '_blank');
                                                            else {
                                                                if (this.props[0].match.params.mainAlias) {
                                                                    window.open(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/information`, '_blank');
                                                                } else {
                                                                    window.open(`/${this.props[0].match.params.alias}/information`, '_blank');
                                                                }
                                                            }
                                                        }}
                                                        seekCareHandler={() => {
                                                            if (this.props.uData) {
                                                                if (this.props[0].match.params.mainAlias) {
                                                                    this.props[0].history.push(`/${this.props[0].match.params.mainAlias}/${this.props[0].match.params.alias}/personal-referral`)
                                                                } else {
                                                                    this.props[0].history.push(`/${this.props[0].match.params.alias}/personal-referral`)
                                                                }

                                                            } else {
                                                                this.setState({
                                                                    bankIdModal: true
                                                                }, () => {
                                                                    this.fetchBankId()
                                                                })
                                                            }
                                                        }}
                                                        daybookHandler={() => {
                                                            this.setLocalStorageGroupAlias();
                                                            if (this.props.uData) {
                                                                this.props[0].history.push({
                                                                    pathname: `/my-data/account`,
                                                                    state: { tabIndex: 2 }
                                                                })
                                                            } else {
                                                                this.setState({
                                                                    bankIdModalDaybook: true
                                                                }, () => {
                                                                    this.fetchBankIdDaybook()
                                                                })
                                                            }
                                                        }}
                                                        dropInHandler={() => {
                                                            this.checkDropInForms();
                                                        }}
                                                        chooseTimeHandle={() => {
                                                            this.webBookingCheck()
                                                        }}

                                                        waitingRoomHandler={() => {
                                                            if (this.props.uData) {

                                                                this.props[0].history.push(`/waiting-room`)
                                                            } else {
                                                                this.setState({
                                                                    bankIdModalWaitingRoom: true
                                                                })
                                                            }
                                                        }}
                                                    />
                                    }
                                </div>

                                {/* ----- */}

                                {
                                    this.state.data.footerSettings ?
                                        <FooterComponent {...this.props} data={this.state.data} />

                                        :
                                        <div className="landing-footer footer-space">
                                            <Container>
                                                <Row>
                                                    <Col lg="12">
                                                        <ul className="landing-footer">
                                                            {this.state.data.privacyPolicy ? <li><Link to={`/${this.props[0].match.params.alias}/privacy-policy`} target="_blank"> {'Privacy policy'.translate(this.props.lang)} </Link></li> : null}
                                                            {this.state.data.termsOfUse ? <li><a href={`/${this.props[0].match.params.alias}/terms-of-use`} target="_blank"> {'Terms of use'.translate(this.props.lang)} </a></li> : null}
                                                            {this.state.data.accessibilityReport ? <li><a href={`/${this.props[0].match.params.alias}/accessibility-report`} target="_blank"> {'Accessibility Report'.translate(this.props.lang)} </a></li> : null}
                                                        </ul>
                                                    </Col>
                                                    <Col lg="12">
                                                        <ul className="landing-footer landing-footer-list">
                                                            <li>{this.state.data.address ? this.state.data.address[0] ? this.state.data.address[1] || this.state.data.address[2] ? this.state.data.address[0] + ',' : this.state.data.address[0] : '' : ''}</li>
                                                            <li>{this.state.data.address ? this.state.data.address[1] ? this.state.data.address[2] ? this.state.data.address[1] + ',' : this.state.data.address[1] : '' : ''}</li>
                                                            <li>{this.state.data.address ? this.state.data.address[2] : ''}</li>
                                                        </ul>

                                                    </Col>
                                                </Row>
                                            </Container>
                                        </div>
                                }




                            </Col>

                        </Row>
                    </Container>
                }

                {this.state.error ?

                    <Modal isOpen={this.state.error} centered>

                        <ModalBody className="delete-modal">
                            {/* <img src={error} /> */}
                            <div className="message">
                                {
                                    this.state.error
                                }
                            </div>
                        </ModalBody>
                        <ModalFooter className='buttons-right-blue'>
                            <Button style={{ minWidth: 100 }} type='button' color='primary' onClick={() => this.setState({ error: null })}>
                                {'Close'.translate(this.props.lang)}
                            </Button>
                        </ModalFooter>
                    </Modal>

                    :
                    null
                }

                {
                    this.state.bankIdModal ?
                        <BankIdModal
                            {...this.props}
                            checkLastLogin={true}
                            isOpen={this.state.bankIdModal}
                            stateForOpen='bankIdModal'
                            seekCare={true}
                            toggle={() => {

                                if (this.props.uData) {


                                    localStorage.setItem('groupAlias', this.props[0].match.params.alias);

                                    this.props[0].history.push(`/${this.props[0].match.params.alias}/personal-referral`)
                                }
                                this.setState({ bankIdModal: null })

                            }}
                            redirect_url={this.state.bankIdModal}></BankIdModal>
                        :

                        null
                }
                {
                    this.state.bankIdModalDaybook ?
                        <BankIdModal
                            {...this.props}
                            checkLastLogin={true}
                            isOpen={this.state.bankIdModalDaybook}
                            stateForOpen='bankIdModalDaybook'
                            setVerifyRedirectLink={() => {
                                localStorage.setItem('groupAlias', this.props[0].match.params.alias);
                                this.props[0].history.push({
                                    pathname: `/my-data/account`,
                                    state: { tabIndex: 2 }
                                })
                            }}
                            dayBook={true}
                            toggle={() => {


                                this.setState({ bankIdModalDaybook: null })

                            }}
                            redirect_url={this.state.bankIdModalDaybook}></BankIdModal>
                        :

                        null
                }
                {
                    this.state.bankIdModalWaitingRoom ?
                        <BankIdModal
                            {...this.props}
                            checkLastLogin={true}
                            isOpen={this.state.bankIdModalWaitingRoom}
                            stateForOpen='bankIdModalWaitingRoom'
                            waitingRoom={true}
                            toggle={() => {

                                if (this.props.uData) {

                                    localStorage.setItem('groupAlias', this.props[0].match.params.alias);

                                    this.props[0].history.push({
                                        pathname: `/waiting-room`,
                                    })
                                }
                                this.setState({ bankIdModalWaitingRoom: null })

                            }}
                            redirect_url={this.state.bankIdModalWaitingRoom}
                        ></BankIdModal>
                        :
                        null
                }

                {
                    this.state.bankIdModalDropIn ?
                        <BankIdModal
                            {...this.props}
                            checkLastLogin={true}
                            isOpen={this.state.bankIdModalDropIn}
                            stateForOpen={this.state.selectedDropInForm + 'dropinBankId'}
                            dropIn={true}
                            selectedDropInForm={this.state.selectedDropInForm}
                            toggle={() => {

                                if (this.props.uData) {
                                    this.props.registerClinicGroupLogs({
                                        type: 'startCreateReferral',
                                        referralType: 'Drop in',
                                        questionaryId: this.state.selectedDropInForm
                                    })

                                    localStorage.setItem('groupAlias', this.props[0].match.params.alias);

                                    this.props[0].history.push({
                                        pathname: `/${this.props[0].match.params.alias}/drop-in`,
                                        state: { isDropIn: true, dropInClinic: this.state.selectedClinic, selectedDropInForm: this.state.selectedDropInForm }
                                    })
                                }
                                this.setState({ bankIdModalDropIn: null })

                            }}
                            redirect_url={this.state.bankIdModalDropIn}></BankIdModal>
                        :

                        null
                }
                {
                    this.state.mainGroupLoginBankIdModal ?
                        <BankIdModal
                            {...this.props}
                            isOpen={this.state.mainGroupLoginBankIdModal}
                            stateForOpen='mainGroupLoginBankIdModal'
                            checkLastLogin={true}
                            openLastLoginLanding={true}
                            clinicGroupsItems={this.state.data.clinicGroupsItems ? this.state.data.clinicGroupsItems : []}
                            toggle={(alias) => {

                                if (this.props.uData) {
                                    this.props.registerClinicGroupLogs({
                                        type: 'login',
                                        loginType: 'bankid'
                                    })
                                    let link = '/';
                                    if (this.props[0].match.params.alias) {
                                        link += `${this.props[0].match.params.alias}`
                                    }
                                    if (alias) {
                                        link += '/';
                                        link += alias;
                                    }

                                    this.props[0].history.push(link)

                                }
                                this.setState({ mainGroupLoginBankIdModal: null })

                            }}
                            redirect_url={this.state.mainGroupLoginBankIdModal}></BankIdModal>
                        :
                        null
                }
                {
                    this.state.loginBankIdModal ?
                        <BankIdModal
                            {...this.props}
                            isOpen={this.state.loginBankIdModal}
                            stateForOpen='loginBankIdModal'
                            checkLastLogin={true}
                            toggle={() => {

                                if (this.props.uData) {
                                    this.props.registerClinicGroupLogs({
                                        type: 'login',
                                        loginType: 'bankid'
                                    })
                                    localStorage.setItem('groupAlias', this.props[0].match.params.alias);

                                }
                                this.setState({ loginBankIdModal: null })

                            }}
                            redirect_url={this.state.loginBankIdModal}></BankIdModal>

                        :

                        null
                }
                {
                    this.state.bankIdModal1 ?
                        <BankIdModal
                            {...this.props}
                            checkLastLogin={true}
                            isOpen={this.state.bankIdModal1}
                            stateForOpen='bankIdModal1'
                            myReferrals={true}
                            toggle={() => {

                                if (this.props.uData) {

                                    localStorage.setItem('groupAlias', this.props[0].match.params.alias);
                                    if (!this.props.uData.haveReferrals && !this.props.uData.havePersonalReferrals) {
                                        this.setState({
                                            error: 'You have no active issues with us...'.translate(this.props.lang),
                                            bankIdModal1: null
                                        })
                                        return;
                                    }

                                    this.props[0].history.push(`/my-data/personal-referrals/referrals`)
                                }
                                this.setState({ bankIdModal1: null })

                            }}
                            redirect_url={this.state.bankIdModal1}></BankIdModal>
                        :

                        null
                }


                {this.state.error ?
                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>
                    :
                    null

                }
                {
                    this.state.searchedReferrals ?
                        <Modal isOpen={this.state.searchedReferrals} centered>
                            <ModalHeader style={{ display: 'flex', justifyContent: 'center' }}>
                                {'What do you need help with?'.translate(this.props.lang)}
                            </ModalHeader>
                            <ModalBody className="delete-modal">
                                <CustomSelectWithSearch
                                    isInputClearable={true}
                                    lang={this.props.lang}
                                    items={this.state.searchedReferrals.filter(item => !item.nonVisible).map((item, idx) => {
                                        return {
                                            name: item.name,
                                            value: item._id
                                        }
                                    })}
                                    value={this.state.selectedReferral}
                                    hideSearchField={this.state.clinicGroup?.hideFormSearchFild}
                                    maxHeight={'50vh'}
                                    onChange={(e) => {
                                        if (e && e.value && this.state.searchedReferrals.filter(item => item._id === e.value).length) {
                                            this.setState({ selectedReferral: e.value }, () => {
                                                let referral = null;
                                                for (let i = 0; i < this.state.searchedReferrals.length; i++) {
                                                    if (this.state.searchedReferrals[i]._id == e.value) {
                                                        referral = this.state.searchedReferrals[i];
                                                        break;
                                                    }
                                                }
                                                this.setState({
                                                    selectedReferral: e.value,
                                                    referral,
                                                }, () => {
                                                    this.openCalendar()
                                                });
                                            })
                                        } else {
                                            this.setState({ selectedReferral: null })
                                        }


                                    }}
                                />
                            </ModalBody>
                            <ModalFooter style={{ display: 'flex', justifyContent: 'center' }} className='buttons-right-blue'>
                                <Button color='primary' onClick={() => {
                                    this.setState({ searchedReferrals: false })
                                }}>{'Cancel'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }

                <iframe ref={(node) => this.appIframe = node} width="1" height="1" style={{ visibility: "hidden" }}></iframe>

                {this.state.userVerificationData ? <VerifyAccountComponent
                    {...this.props}
                    {...this.state}
                    {...this.state.userVerificationData}
                    onClose={this.close2FAModal}
                    onLogin={this.login2FA}
                    isOpen={this.state.userVerificationData ? true : false}
                /> : null}

                {
                    this.state.twoFactorAuthForbidden ? <Modal
                        zIndex={99999}
                        size='md'
                        centered
                        isOpen={this.state.twoFactorAuthForbidden}
                    >
                        <ModalBody style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
                            <p style={{ textAlign: 'center', margin: 0, padding: 0, }}>{typeof this.state.twoFactorAuthForbidden === 'string' ? this.state.twoFactorAuthForbidden.translate(this.props.lang) : 'This clinic does not accept cases from patients who use two factor authentication, if their account is not verified with them.'.translate(this.props.lang)}</p>
                        </ModalBody>
                        <ModalFooter style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Button onClick={this.navigateBackToProfile} style={{ minWidth: 100 }}>
                                {'Ok'.translate(this.props.lang)}
                            </Button>
                        </ModalFooter>
                    </Modal> : null
                }

                <AgeLimitErrorModal {...this.props} />

            </div>
        );




    }
}

const selector = formValueSelector('modalForm');

export default connect(state => {
    return { selectedWaitingTimeType: selector(state, 'selectedWaitingTimeType') }

}, {
    changeMinValue: value => change("modalForm", "waitingMin", value),
    changeMaxValue: value => change("modalForm", "waitingMax", value),
    changeSelectedWaitingTimeType: value => change("modalForm", "selectedWaitingTimeType", value),

})(Page(LandingInformationPage));
